// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__3gwEb","footer":"ModalError_footer__2e755"};